import { render } from "./MenuDesignTable.vue?vue&type=template&id=60aaf6d8"
import script from "./MenuDesignTable.vue?vue&type=script&lang=js"
export * from "./MenuDesignTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__